export default __webpack_public_path__ + "static/dum-292c71c1581812092aac3a6b95948f2a.webp";